<template>
	<div class="stage stage--impactcalculator" :class="'round_'+currentRound" :style="{ 'background-image': backgroundImage }">
		
		<div class="content-container">

			<div class="header__container">
				
				<div class="header" style="position: relative">
					{{questionData.header}}
				</div>
				<div class="text">
					<p>{{questionData.questiontext}}</p>
				</div>

				<div class="info" style="position: relative">
					{{questionData.info}}
				</div>
			</div>


			<div class="btn__explanation" @click="showExplanationPopup">
				<i class="fa fa-question"></i>
			</div>


			<div class="card card__impactcalculator">

				<div class="info info_2" style="position: relative; display: none;">
					{{questionData.info}}
				</div>

				<RoundSlider :sliderValue="sliderValue" @round-slide="slideChange" :maxValue="+questionData.maxvalue" :stepSize="+questionData.stepsize" :identifier="1" :visual="baseUrl + questionData.visual"></RoundSlider>

				<div class="counter_container">
					<p class="counter_explanation">
						{{questionData.info}}
					</p>
					<ul class="counter_parent">
						<li class="couter__item" v-for="display in displayValues">{{ display }}</li>
					</ul>

					<div class="counter_text">
						<div class="counter_text__textHolder">
							{{comment}}
						</div>
					</div>
				</div>

			</div>

			<!--<div class="couter__label col-xs-4">{{ question.info }}</div>-->
			
			<!--<Question :header="questionData.header" :text="questionData.caption" :visual="questionData.visual"/>-->

			<!--<div class="impactcalculator__button btn btn-progres " @click="()=>{onQuestionAnswer(false)}">volgende</div>-->


			<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:on-click="hideExplanationPopup"/>
			
		</div>	
	</div>
</template>

<script>

	import RoundSlider from './RoundSlider.vue';

	import { url} from '../../../const/base';
	import { mapGetters , mapActions } from 'vuex';
	import Velocity from 'velocity-animate';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		components:{
			RoundSlider,
			ExplanationPopup,
		},

		data(){
			return{
				baseUrl : url,
				displayValues: [],
				sliderValue: 0,
				userAnswers:[],
				explanationPopupActive: false,
			}
		},

		mounted(){
			this.showTransitorScore(false);
			this.setSliderValue(0);
			this.setNextButtonAction(this.next).then(()=>{
				this.showNextButton();
			});
		},

		computed: {

			...mapGetters([
				"lastQuestion",
				"currentBlock",
				"currentStage",
				"currentRound",
				"currentQuestion",
				"roundCount",
				"scores",
				"questionData",
				"roundData",
				"roundScore"
			]),

			comment(){
				let commentText = "Undefined";
				this.questionData.comments.forEach((comment)=>{
					if(this.sliderValue >= +comment.frompoint) commentText = comment.comment_text;
				});
				return commentText;
			},

			
			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

		},

		watch:{
			currentQuestion : function(val){
				this.setSliderValue(0);
			},
		},

		methods:{
			...mapActions([
				'setNextButtonAction',
				"setFeedbackData",
				'showNextButton',
				'hideNextButton',
				"playAudio",
				"increaseTransitorScore",
                "showTransitorScore",
				"completeRound",
				"toNextQuestion",
				"addRoundScore",
				"setScore",
				"logAnswers"
			]),

			hideExplanationPopup(){
				this.explanationPopupActive = false;
				$('.btn--transition').removeClass('idle');
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
				$('.btn--transition').addClass('idle');
			},


			slideChange: function(data) {
				this.setSliderValue(data.value);
			},

			setSliderValue(val){
				this.sliderValue = val;
				let stringValue = String(val);
				let maxValue = this.questionData.maxvalue;

				this.displayValues = stringValue.split("");
				let maxDisplayValue = String(maxValue).split("");

				let diffValue = maxDisplayValue.length - this.displayValues.length;

				for (var i = diffValue - 1; i >= 0; i--) {
					this.displayValues.unshift('0');
				};
			},

			next(){
				this.userAnswers.push(this.sliderValue);
				if(this.lastQuestion){
					this.hideNextButton().then(()=>
					{
						setTimeout(()=>{
							this.completeRound();
						},500);

					});

					this.setFeedbackData({
							userAnswers: this.userAnswers,
							totalScores: 10
						});

					this.logAnswers(this.userAnswers);
				}
				else{
					this.toNextQuestion().then(()=>{
						this.setButtonAction();
					});
				}



			},

			setButtonAction(){
				this.hideNextButton().then(()=>{
					this.setNextButtonAction(this.next).then(()=>{
						setTimeout(()=>{
							this.showNextButton();
						},200);
					});
				})
			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/impactcalculator/Index.vue